"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCalculationEngineService = void 0;
var ProductCalculationEngineService;
(function (ProductCalculationEngineService) {
    ProductCalculationEngineService["COX_FIE"] = "CoxFIExpress";
    ProductCalculationEngineService["OTHER"] = "Other";
    ProductCalculationEngineService["PROVIDER_EXCHANGE_NETWORK"] = "ProviderExchangeNetwork";
    ProductCalculationEngineService["ROUTE_1"] = "RouteOne";
    ProductCalculationEngineService["STONE_EAGLE"] = "StoneEagle";
})(ProductCalculationEngineService = exports.ProductCalculationEngineService || (exports.ProductCalculationEngineService = {}));
